import { render, staticRenderFns } from "./PageMainEventFollowup.vue?vue&type=template&id=4f857312&scoped=true&"
import script from "./PageMainEventFollowup.vue?vue&type=script&lang=js&"
export * from "./PageMainEventFollowup.vue?vue&type=script&lang=js&"
import style0 from "./PageMainEventFollowup.vue?vue&type=style&index=0&id=4f857312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f857312",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VContainer,VDivider,VProgressCircular,VProgressLinear,VSelect,VSimpleTable,VSpacer})
